import * as platformNav from '@/features/platform/nav';
import * as accountingNav from '@/features/accounting/nav';
import * as operationsNav from '@/features/operations/nav';
import * as billingNav from '@/features/billing/nav';
import * as hrNav from '@/features/hr/nav';

// One explicit order shared by the sidebar, command search and ARIA catalog.
export const navigation = [
  ...accountingNav.clientes,
  ...platformNav.inicio,
  ...platformNav.dia,
  ...operationsNav.dia,
  ...platformNav.analitica,
  ...billingNav.dia,
  ...accountingNav.finanzas,
  ...operationsNav.operaciones,
  ...hrNav.equipo,
  ...hrNav.personal,
  ...platformNav.sistema,
];
